import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setDisplayElementOptionsModal} from "../../store/configuratorStateSlice";
import PropTypes from "prop-types";
import ElementModuleOptionsSelection from "./ElementModuleOptionsSelection";

const ElementSectionOptionSelectionModal = (props) => {
    const displayElementOptionModal = useSelector(state => state.configuratorStateReducer.uiState.displayElementOptionModal);
    const elementOptionalDisplaySection = useSelector(state => state.configuratorStateReducer.elementOptionalDisplaySection)
    const elements = useSelector(state => state.productElementsReducer.elements_with_selections)
    const sections = props.elementSummary.sections;
    const dispatch = useDispatch();
    const [filteredElements, setFilteredElements] = useState([]);
    useEffect(() => {
        setupFilteredElements();
    }, [elements]);

    const setupFilteredElements = () => {
        const filteredElementsWithKeys = [];
        let index = 0;
        // separate elements out based on section
        for(let element of elements) {
            if( element.section_number === elementOptionalDisplaySection) {
                const elementWithElementKey = Object.assign({}, element, {
                    elementKey: index
                })
                filteredElementsWithKeys.push(elementWithElementKey);
            }
            index++
        }
        setFilteredElements(filteredElementsWithKeys)
    }



    const styles = {
        modalStyle: {
            position: 'relative',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            width: '700px',
            padding: '20px',
            minHeight: '200px',
        },
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10,
            backgroundColor: 'rgba(0,0,0,0.5)'
        },
        close: {
            position: 'absolute',
            right: '10px',
            top: '10px',
            cursor: 'pointer',
        },
        submit: {
            position: 'absolute',
            left: '15px',
            bottom: '15px',
            marginBottom: 0
        }
    }

    const handleClose = (e) => {
        dispatch(setDisplayElementOptionsModal(false));
    }


    const displayElementsWithinSection = () => {
        const sectionDetails = sections.find(s => s.section_number == elementOptionalDisplaySection);
        const toDisplay = [];
        let i = 0;
         for(let filteredElement of filteredElements) {
             const matchingSummaryItem = sectionDetails.elements[i];
             toDisplay.push(<ElementModuleOptionsSelection key={`section-${i}`} element={filteredElement} elements={filteredElements} summaryElement={matchingSummaryItem} />)
             i++
         }

        return toDisplay;
    }

    const handleUpdate = () => {
        dispatch(setDisplayElementOptionsModal(false));
    }

    const displaySectionName = () => {
        if(elementOptionalDisplaySection === 0) {
            return <h3>Connector Options</h3>
        } else {
            return <h3>Section {elementOptionalDisplaySection} Options</h3>
        }
    }

    if (!displayElementOptionModal) {
        return null
    }

    return (
        <div style={styles.overlay} className={'element-option-modal'} key={`option-modal-${elementOptionalDisplaySection}`}>
            <div style={styles.modalStyle}>
                <div style={styles.close} onClick={() => handleClose()}>close</div>
                <div style={{marginBottom: '20px'}}>{ displaySectionName() }</div>
                <div style={{marginBottom: '40px'}}>
                    {displayElementsWithinSection()}
                </div>
                <div className={'button'} style={styles.submit} onClick={(e) => handleUpdate(e)}>Update</div>
            </div>
        </div>
    );
}

ElementSectionOptionSelectionModal.props = {
    elementSummary: PropTypes.object.isRequired
}

export default ElementSectionOptionSelectionModal;